module.exports = __webpack_public_path__ + "static/media/btg_banner.5d838a82.png";